<template>
    <div class="box">
        <inner-table id="innerFamily" ref="familyList" :listviewurl="'rsgl.archiveFamilyMembers.list'" :can-edit="canEdit" :can-delete="canEdit" :link-prop-name="'archivesId'" />
    </div>
</template>

<script>
const moment = require('moment')
export default {
    components: {
    },
    props: {
        vo: { type: Object, default: function() { return {} } },
        canEdit: { type: Number, default: 0 }
    },
    data() {
        return {
        }
    },
    computed: {},
    watch: {},
    created: function() {
    },
    mounted: function() {
    },
    methods: {
        // onInnerTableListDataBeforeLoad($scope, qparams) {
        //     qparams.urlsearch = `archivesId:${this.vo?.id}`
        // },
        onInnerTableListDataLoaded($scope, pageInfo) {
            pageInfo.list.forEach(v => {
                v.memberBirthday = moment(v.memberBirthday).format('YYYY-MM-DD')
            })
        }
    }
}
</script>

<style scoped>
.header {
    padding:10px 20px;
    background-color: #f2f5fb;
    font-size: 14px;
    font-weight: 500;
}
.box {
   border:1px solid #dee2e6;
}
</style>

